import { render, staticRenderFns } from "./CrmKanbanApi.vue?vue&type=template&id=6f8a1d90&lang=pug&"
import script from "./CrmKanbanApi.vue?vue&type=script&lang=js&"
export * from "./CrmKanbanApi.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports